import { useContext } from 'react';
import { AuthContext } from '@/app/providers/AuthProvider';
import type { AuthContextValue } from '@/app/providers/AuthProvider';

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
